import { render, staticRenderFns } from "./Uebersicht.vue?vue&type=template&id=b4e6d90c&"
import script from "./Uebersicht.vue?vue&type=script&lang=js&"
export * from "./Uebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports